import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-bscheck-box',
	templateUrl:'./BSCheckBoxPage.html',
	styles: [],
	styleUrls:['./BSCheckBoxPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BSCheckBoxPage
{
	mdContent_86 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.buttons.checkbox.BSCheckBox;
\`\`\``;
	mdContent_87 = `\`\`\`java
new BSCheckBox<>()
\`\`\``;
	mdContent_88 = `\`\`\`java
var group = new BSCheckBoxGroup<>();
group.setForm(myForm);
group.addLabel("Accept Terms");
var input = new InputCheckBoxType<>();
group.setInput(input);
input.bind("acceptTerms");
\`\`\``;
}
